import api from './authService'

export interface Permiso {
  id_permiso: number
  codigo: string
  nombre: string
  descripcion: string
  categoria: string
}

export interface Rol {
  id_rol: number
  nombre: string
  descripcion: string
  es_sistema: boolean
  permisos_count: number
  permisos: Permiso[]
}

export interface RolCrear {
  nombre: string
  descripcion: string
  permisos_ids: number[]
}

export interface RolActualizar {
  nombre?: string
  descripcion?: string
  permisos_ids?: number[]
}

export const rolesService = {
  obtenerRoles: async (): Promise<Rol[]> => {
    const response = await api.get('/api/admin/roles')
    return response.data
  },

  obtenerPermisos: async (): Promise<Permiso[]> => {
    const response = await api.get('/api/admin/permisos')
    return response.data
  },

  crearRol: async (rol: RolCrear): Promise<Rol> => {
    const response = await api.post('/api/admin/roles', rol)
    return response.data
  },

  actualizarRol: async (id: number, rol: RolActualizar): Promise<any> => {
    const response = await api.put(`/api/admin/roles/${id}`, rol)
    return response.data
  },

  eliminarRol: async (id: number): Promise<any> => {
    const response = await api.delete(`/api/admin/roles/${id}`)
    return response.data
  }
}
